// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconEllipsisVertical = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 20C27.6807 20 25 17.3193 25 13C25 8.68073 27.6807 6 32 6C36.3193 6 39 8.68073 39 13C39 17.3193 36.3193 20 32 20ZM39 32C39 27.6807 36.3193 25 32 25C27.6807 25 25 27.6807 25 32C25 36.3193 27.6807 39 32 39C36.3193 39 39 36.3193 39 32ZM39 51C39 46.6807 36.3193 44 32 44C27.6807 44 25 46.6807 25 51C25 55.3193 27.6807 58 32 58C36.3193 58 39 55.3193 39 51Z" />
    </svg>
  );
};
